var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',[_vm._v("账户列表")]),(_vm.dataShow)?_c('datagrid',{attrs:{"columns":_vm.cols,"subListName":"","dataList":_vm.dataList,"pagination":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var columns = ref.columns;
var data = ref.data;
return undefined}}],null,false,3637207249)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }